import { useAjaxCall } from '~/_shared/utils/hooks/useAjaxCall';
import { cancelWMSOptimizedTerritory } from '~/store/boundaries/boundaries.repository';

export const useCancelWMSOptimizedTerritories = () => {
  const { invokeAjax, isLoading } = useAjaxCall((clientId: number, territoryId: number) =>
    cancelWMSOptimizedTerritory(clientId, territoryId)
  );

  return {
    isLoading,
    cancelWMSOptimizedTerritory: invokeAjax,
  };
};
